import React from 'react';
import B2BFrameworks from './components/b2b-frameworks/B2BFrameworks';
import B2BIndicators from './components/b2b-indicators/B2BIndicators';
import B2BLanguages from './components/b2b-languages/B2BLanguages';
import B2BPlans from './components/b2b-plans/B2BPlans';
import B2BReporting from './components/b2b-reporting/B2BReporting';
import B2BSampling from './components/b2b-sampling/B2BSampling';
import B2BUsers from './components/b2b-users/B2BUsers';
import B2BSocial from './components/b2b-social/B2BSocial';
import B2BSystem from './components/b2b-system/B2BSystem';

const routes = [
    { path: '/users/*', element: <B2BUsers /> },
    { path: '/languages/*', element: <B2BLanguages /> },
    { path: '/indicators/*', element: <B2BIndicators /> },
    { path: '/frameworks/*', element: <B2BFrameworks /> },
    { path: '/plans/*', element: <B2BPlans /> },
    { path: '/reporting/*', element: <B2BReporting /> },
    { path: '/iot-integrations/*', element: <B2BSampling /> },
    { path: '/social/*', element: <B2BSocial /> },
    { path: '/system/*', element: <B2BSystem /> },
    { path: '*', element: <h1>Not Found</h1> }
];

export default routes;